import * as React from "react";
import * as R from "ramda";
import {Field} from "react-final-form";
import {connect} from "react-redux";
import {Oficina} from "../modelo/Oficina";

class Oficinas extends React.Component<OficinasProps> {

    render() {
        const {className, oficinas} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {oficinas.map(oficina => {
                                return <option key={oficina.codigo} value={oficina.codigo}>{oficina.nombre}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

}

interface OficinasProps {
    name: string,
    className?: string,
    oficinas?: Array<Oficina>
}


export default connect((store: any, props: any) => {
    return {
        ...props,
        oficinas: R.pathOr([], ["inicio", "oficinas"])(store)
    };
})(Oficinas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/Oficinas.tsx